"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useOnChangeAnimationEffect = _interopRequireDefault(require("../../hooks/useOnChangeAnimationEffect"));

var _useOnChangeCssVarEffect = _interopRequireDefault(require("../../hooks/useOnChangeCssVarEffect"));

var _useOnChangeDisabledEffect = _interopRequireDefault(require("../../hooks/useOnChangeDisabledEffect"));

var _useOnHover2 = _interopRequireDefault(require("../../hooks/useOnHover"));

var _useToggleAnimation = _interopRequireDefault(require("../../hooks/useToggleAnimation"));

var GlitchBase = function GlitchBase(_ref) {
  var children = _ref.children,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 1000 : _ref$duration,
      glitchId = _ref.glitchId,
      _ref$iterationCount = _ref.iterationCount,
      iterationCount = _ref$iterationCount === void 0 ? 'infinite' : _ref$iterationCount,
      _ref$onHover = _ref.onHover,
      onHover = _ref$onHover === void 0 ? false : _ref$onHover,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave,
      _ref$restCssVarList = _ref.restCssVarList,
      restCssVarList = _ref$restCssVarList === void 0 ? '[]' : _ref$restCssVarList,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["children", "disabled", "duration", "glitchId", "iterationCount", "onHover", "onMouseEnter", "onMouseLeave", "restCssVarList"]);
  var glitchAnimationRef = (0, _react.useRef)(null);
  var toggleAnimation = (0, _useToggleAnimation.default)(glitchAnimationRef, glitchId);

  var _useOnHover = (0, _useOnHover2.default)({
    callbackEvents: {
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave
    },
    onHover: onHover,
    toggleAnimation: toggleAnimation
  }),
      handleOnMouseEnter = _useOnHover.handleOnMouseEnter,
      handleOnMouseLeave = _useOnHover.handleOnMouseLeave;

  (0, _useOnChangeDisabledEffect.default)(toggleAnimation, {
    disabled: disabled,
    onHover: onHover
  });
  (0, _useOnChangeAnimationEffect.default)(glitchAnimationRef, {
    iterationCount: iterationCount,
    duration: duration
  });
  (0, _useOnChangeCssVarEffect.default)(glitchAnimationRef, restCssVarList);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    onMouseEnter: handleOnMouseEnter,
    onMouseLeave: handleOnMouseLeave
  }, rest), /*#__PURE__*/_react.default.createElement("div", {
    ref: glitchAnimationRef
  }, Array.isArray(children) ? [children[0], /*#__PURE__*/(0, _react.cloneElement)(children[1], {
    rootRef: glitchAnimationRef,
    key: 1
  })] : children));
};

var _default = /*#__PURE__*/(0, _react.memo)(GlitchBase);

exports.default = _default;
GlitchBase.propTypes = {
  children: _propTypes.default.node.isRequired,
  disabled: _propTypes.default.bool,
  duration: _propTypes.default.number,
  glitchId: _propTypes.default.string,
  iterationCount: _propTypes.default.string,
  onHover: _propTypes.default.bool,
  onMouseEnter: _propTypes.default.func,
  onMouseLeave: _propTypes.default.func,
  restCssVarList: _propTypes.default.string
};